/**
 * Override mobile notifications styles
 */

import { SM_SCREEN_MAX_WIDTH } from '@/components/content/OrderHistoryDetails/constants';
import { SxProps, Theme } from '@mui/material';

export const snackBarSX: SxProps<Theme> = {
	maxWidth: '100%',
	p: 2,
	[`@media (max-width: ${SM_SCREEN_MAX_WIDTH}px)`]: {
		bottom: '60px',
		width: '100%',
	},
};
